export { default as store } from './store'